<template>
  <div>
    <dx-products
      v-model="clientType"
      :headline="$t('partnerPortal.calculateOffer')"
      :tab-data="tabOptions"
      tab-class="mb-5 col-md-8 mx-auto"
    >
      <template slot="tariff">
        <dx-tariff-list
          :client-type="clientType"
        />
      </template>
    </dx-products>

    <div
      v-if="clientType === 'company'"
      class="d-lg-flex mt-5 p-3 special-tariff"
    >
      <h3
        class="mr-3 h4 icon-left"
        v-html="$t('partnerPortal.tariff.special.headline')"
      />
      <div class="px-2 py-3 px-lg-5 py-lg-4 content-right">
        {{ $t('partnerPortal.tariff.special.text') }}
      </div>
    </div>
  </div>
</template>

<script>
import { DxProducts } from '@sumcumo/dextra-frontend-component-lib'
import DxTariffList from '~/domains/partnerPortal/components/DX-TariffList'

export default {
  name: 'Products',
  components: {
    DxProducts,
    DxTariffList,
  },
  data() {
    return {
      clientType: 'private',
      tabOptions: [
        {
          value: 'private', text: this.$t('partnerPortal.privateClient'), id: 'private',
        },
        {
          value: 'company', text: this.$t('partnerPortal.company'), id: 'company',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import './index';
</style>
